import { Dialog, DialogProps } from "@minuthq/meatball-ui-react"

import { useTranslate } from "src/i18n/useTranslate"

export function MDialog({ confirmLabel, closeLabel, ...props }: DialogProps) {
  const { t, langKeys } = useTranslate()

  const translatedConfirmLabel = confirmLabel ?? t(langKeys.ok)
  const translatedCloseLabel = closeLabel ?? t(langKeys.cancel)

  return (
    <Dialog
      {...props}
      closeLabel={translatedCloseLabel}
      confirmLabel={translatedConfirmLabel}
    />
  )
}
